import { PermissionsEnum } from '@/auth/interfaces';

export const SAVE_PROMOCION_PEMISSIONS = [
  PermissionsEnum.api_view_plan,
  PermissionsEnum.api_view_pais,
  PermissionsEnum.api_view_provincia,
  PermissionsEnum.api_view_ciudad,
  PermissionsEnum.api_view_zona,
  PermissionsEnum.api_view_sector,
];
